import { instance as Axios } from "../api/_axios"


export default async function query(
  { host, method, urlParams, bodyPayload, model = '', pathPrefix = '/api/v1/', path = '', pathPostfix = "", timeout, headers }) {
  // const url = host[window.location.hostname] + pathPrefix + model + path
  const url = `${host}${pathPrefix}${model === '' ? '' : model + 's'}${path}${pathPostfix}`
  // console.log(url);
  try {
    let params = {
      method: method,
      url: url,
      params: urlParams,
      data: bodyPayload,
      // this setting will call every request with cookies
      withCredentials: true,
    }
    // if (headers) {
    //   params.headers = headers;
    //   for(let key of Object.keys(headers)){
    //     Axios.defaults.headers.common[key] = headers[key]
    //   }
    // }
    if (timeout) {
      params.timeout = timeout
    }
    const response = await Axios(params)

    if (response.data.ret) {
      return response.data
    } else {
      if (response.data.error) {
        return Promise.reject(response.data)
        // _store.commit('SET_PARAMS',{key:'showError',  data: true})
        // _store.commit('SET_PARAMS',{key:'error',      data: response.data.error})
        // _store.commit('SET_PARAMS',{key:'error_data', data: response.data.error_data})
      }
      return response.data
    }
  } catch (error) {
    error.error = error.message
    return Promise.reject(error)
  }
}